/**
 * fteColor — couleur graduée du taux d'activité (ETP) par tranche de 20% :
 * 100% vert (sauge) → 0% rouge (terracotta). Partagé entre la page Year-end
 * et son impression pour un visuel identique.
 */
// Paliers descendants : chaque taux usuel (100/80/60/40/20/0) a sa couleur
// distincte, du vert au rouge en passant par les jaunes / moutarde foncé.
export const FTE_RAMP = [
  { min: 100, background: '#A8C97E', color: '#39521F' },  // 100 % vert
  { min: 80,  background: '#CFE0A0', color: '#51662A' },  // 80 %  vert-jaune
  { min: 60,  background: '#E9E58E', color: '#6E6620' },  // 60 %  jaune
  { min: 40,  background: '#E2C964', color: '#6B5717' },  // 40 %  jaune doré
  { min: 20,  background: '#C99B33', color: '#5A440C' },  // 20 %  moutarde foncé
  { min: 0,   background: '#E2A083', color: '#963F25' },  // 0 %   rouge
];

export function fteColor(pct) {
  const p = Number(pct) || 0;
  const step = FTE_RAMP.find(s => p >= s.min) || FTE_RAMP[FTE_RAMP.length - 1];
  return { background: step.background, color: step.color };
}

/**
 * Style d'une cellule de la grille mensuelle Year-end, par kind. Utilisé à
 * l'identique par la page et l'impression (couleurs cohérentes écran ↔ PDF).
 *   - active           : couleur graduée selon le taux
 *   - before / after   : borne d'arrivée / départ (terracotta léger)
 *   - none             : aucun contrat ce mois (gris)
 * Toutes affichent leur taux (0% inclus) — pas de tiret.
 */
export function cellFteStyle(kind, pct) {
  if (kind === 'active') return fteColor(pct);
  // before / after / none : aucun contrat actif ce mois (0%) → même rouge
  // terracotta léger, pour une lecture cohérente (plus de gris isolé).
  return { background: 'var(--terracotta-light)', color: 'var(--terracotta-dark)' };
}
